import { graphql } from '@generated/gql';

export const CREATE_ORGANIZATION = graphql(/** GraphQL */ `
  mutation newOrganizationModalCreateOrganization(
    $input: CreateOrganizationInput!
  ) {
    createOrganization(input: $input) {
      organization {
        id
      }
    }
  }
`);
